import { render, staticRenderFns } from "./ChoroplethMap.vue?vue&type=template&id=4255d193&"
import script from "./ChoroplethMap.vue?vue&type=script&lang=js&"
export * from "./ChoroplethMap.vue?vue&type=script&lang=js&"
import style0 from "./ChoroplethMap.vue?vue&type=style&index=0&id=4255d193&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports